import { render, staticRenderFns } from "./CourseSelect.vue?vue&type=template&id=3b54a612&scoped=true"
import script from "./CourseSelect.vue?vue&type=script&lang=js"
export * from "./CourseSelect.vue?vue&type=script&lang=js"
import style0 from "./CourseSelect.vue?vue&type=style&index=0&id=3b54a612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b54a612",
  null
  
)

export default component.exports